// Gọi API Boss: JSON, cookie phiên, lỗi → ApiError với message tiếng Việt từ server. 401 (ngoài lúc đăng nhập) → hook chuyển về màn đăng nhập.
export class ApiError extends Error {
  constructor(
    public code: string,
    message: string,
    public details?: unknown,
    public status = 0,
  ) {
    super(message);
  }
}

let onUnauthorized: (() => void) | null = null;
export function setUnauthorizedHandler(fn: (() => void) | null): void {
  onUnauthorized = fn;
}

interface Envelope<T> {
  ok: boolean;
  data?: T;
  error?: { code?: string; message?: string; details?: unknown };
}

export async function api<T = unknown>(method: "GET" | "POST" | "PATCH" | "PUT" | "DELETE", path: string, body?: unknown): Promise<T> {
  const init: RequestInit = { method, credentials: "same-origin", headers: { accept: "application/json" } };
  if (body !== undefined && method !== "GET") {
    (init.headers as Record<string, string>)["content-type"] = "application/json; charset=utf-8";
    init.body = JSON.stringify(body);
  }
  let res: Response;
  try {
    res = await fetch(path, init);
  } catch {
    throw new ApiError("network", "Không nối được máy chủ — kiểm tra mạng rồi thử lại");
  }
  const ct = res.headers.get("content-type") ?? "";
  let env: Envelope<T> | null = null;
  if (ct.includes("json")) {
    try {
      env = (await res.json()) as Envelope<T>;
    } catch {
      env = null;
    }
  }
  if (!env) {
    if (res.ok) return undefined as T;
    throw new ApiError(res.status >= 500 ? "internal" : "bad_request", `Máy chủ trả lỗi HTTP ${res.status}`, undefined, res.status);
  }
  if (env.ok) return env.data as T;
  const code = env.error?.code ?? (res.status >= 500 ? "internal" : "bad_request");
  const msg = env.error?.message || `Máy chủ trả lỗi HTTP ${res.status}`;
  if ((res.status === 401 || code === "unauthorized") && !path.startsWith("/api/login")) onUnauthorized?.();
  throw new ApiError(code, msg, env.error?.details ?? undefined, res.status);
}

/** {a:1,b:""} → "?a=1" (bỏ rỗng/null/undefined). */
export function buildQuery(q: Record<string, string | number | string[] | null | undefined>): string {
  const p = new URLSearchParams();
  for (const [k, v] of Object.entries(q)) {
    if (v === undefined || v === null || v === "") continue;
    if (Array.isArray(v)) { for (const x of v) if (x !== "") p.append(k, x); continue; } // (12/10/2026) tham số LẶP ?bundleName=a&bundleName=b (lọc Lịch sử theo các đoạn của một kịch bản đồ thị)
    p.set(k, String(v));
  }
  const s = p.toString();
  return s ? `?${s}` : "";
}

export function errMsg(e: unknown): string {
  if (e instanceof Error) return e.message || "Lỗi không rõ";
  return String(e);
}
